import {AlertPageRequest} from 'src/openapi/admin/models/AlertPageRequest';

export const SCOPE_KEY = 'content-alert';

export function makeAlertQueryKey(userId: number, request: AlertPageRequest): string {
    const stableRequest = {
        ...request,
        generalAlertTypes: [...(request?.generalAlertTypes || [])].sort(),
    };

    return `${userId}::${JSON.stringify(stableRequest)}`;
}
